var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"recommend"}},[_c('a',{attrs:{"id":"auto","href":'line://msg/text/?親愛的朋友，我要邀請你一起加入Beauty美妝生活圈 的LINE好友，最新美妝潮流都在這裡！%0D%0A%0D%0Aline://app/1610553524-JbE9B9WV?c='+this.channelId+'&rec='+this.userId},on:{"click":_vm.recommend}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/Beauty.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c74b4ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recommend.vue
// module id = null
// module chunks = 